// @flow

import * as R from "ramda";

import type { LinkedFieldChatroom } from "src/types";

const getAutoLinkedRooms = (value: LinkedFieldChatroom[]): number[] => {
  const iter = (acc, item) => {
    if (item?.linkAllVersions) {
      acc.push(item.chatroom.id);
    }
    return acc;
  };
  return R.reduce(iter, [], value);
};

export const getOriginChatroomId = (
  roomId: number,
  result: number[],
  chatrooms: {
    [number]: LinkedFieldChatroom,
  },
) =>
  result.find(
    (currOriginRoomId) => chatrooms[currOriginRoomId].chatroom.id === roomId,
  );

export const groupVersionsTogether = (
  result: number[],
  chatrooms: {
    [number]: LinkedFieldChatroom,
  },
) => {
  const selectedRooms = result.map((id) => chatrooms[id]);

  const selectedRoomIds: number[] = selectedRooms.map(
    (room) => room.chatroom.id,
  );

  const autoLinkedRooms = getAutoLinkedRooms(selectedRooms);

  return [selectedRoomIds, autoLinkedRooms];
};
